export const PROJECT_NAV_DRAWER_WIDTHS = {
  WITH_UNIT: {
    FOLDED: '52px',
    XS_SCREEN: '80vh',
    MOBILE: '33%',
    REGULAR: '240px',
  },
  RAW: {
    FOLDED: 52,
    REGULAR: 240,
  },
} as const
